import { InvoiceInfo, InvoiceInfoResp } from '@stores/billing';
import Amex from '@png/cards/amex.png';
import UnionPay from '@png/cards/unionpay.png';
import MasterCard from '@png/cards/mastercard.png';
import DinersClub from '@png/cards/dinersclub.png';
import Discover from '@png/cards/discover.png';
import Visa from '@png/cards/visa.png';
import JCB from '@png/cards/jcb.svg';
import { find } from 'lodash';
import { COUNTRY_CODES } from '@utils/countryCodes';

export const isReviewButtonDisabled = (isInvalidCard: boolean, invoice: InvoiceInfo) =>
  isInvalidCard || isInvoiceInvalid(invoice);

export const getBrandLogo = (type: string | undefined) => {
  switch (type) {
    case 'American Express':
    case 'amex':
      return Amex;
    case 'Diners Club':
    case 'diners':
      return DinersClub;
    case 'Discover':
    case 'discover':
      return Discover;
    case 'MasterCard':
    case 'mastercard':
      return MasterCard;
    case 'Visa':
    case 'visa':
      return Visa;
    case 'UnionPay':
    case 'unionpay':
      return UnionPay;
    case 'jcb':
    case 'JCB':
      return JCB;
    default:
      return '';
  }
};

export const getBrandName = (type: string) => {
  switch (type) {
    case 'amex':
      return 'American Express';
    case 'diners':
      return 'Diners Club';
    case 'discover':
      return 'Discover';
    case 'mastercard':
      return 'MasterCard';
    case 'visa':
      return 'Visa';
    case 'unionpay':
      return 'UnionPay';
    case 'jcb':
      return 'JCB';
    default:
      return '';
  }
};

interface IPlan {
  metadata: {
    planType: 'free' | 'pro';
    credits: number;
    price: string;
  };
}
export const serverPricingToClient = (response: IPlan[]) => {
  const freePlan = response.find((plan) => plan.metadata.planType === 'free');
  const proPlan = response.find((plan) => plan.metadata.planType === 'pro');
  return {
    free: {
      cost: freePlan?.metadata?.price || '$xx',
      credits: freePlan?.metadata?.credits || 0,
    },
    pro: {
      cost: proPlan?.metadata?.price || '$xx',
      credits: proPlan?.metadata?.credits || 0,
    },
  };
};

export const serverInvoiceToClient = (invoiceInfo: InvoiceInfoResp) => {
  const { line1, line2, city, state, country, postalCode } = invoiceInfo.address || {};
  return {
    company: invoiceInfo?.name?.trim(),
    address: {
      street: line1?.trim(),
      unit: line2?.trim(),
      city: city?.trim(),
      state: state?.trim(),
      postalCode: postalCode?.trim(),
      country,
    },
  };
};

export const getCountryNameFromCode = (code: string) => {
  const country = find(COUNTRY_CODES, { code });
  if (country) {
    return country.name;
  }
  return '';
};

export const isInvoiceInvalid = (invoice: InvoiceInfo): boolean =>
  !invoice.company ||
  !invoice.address.street ||
  !invoice.address.city ||
  !invoice.address.state ||
  !invoice.address.country ||
  !invoice.address.postalCode;
